import './ProjectGrid.css';

function ProjectGrid({ projects, onClose, onProjectClick }) {
  return (
    <div
      role="dialog"
      aria-modal="true"
      className="pg-modal__overlay"
      onClick={onClose}
    >
      <div className="pg-modal__panel" onClick={(e) => e.stopPropagation()}>
        <div className="pg-modal__header">
          <div className="pg-modal__title">
            <span className="pg-modal__title-icon">✨</span>
            vibe coding
          </div>
          <button
            type="button"
            className="pg-modal__close"
            onClick={onClose}
            aria-label="关闭"
            title="关闭"
          >
            ×
          </button>
        </div>
        <div className="pg-modal__body">
          <div className="pg-grid">
            {projects.map((project) => (
              <button
                key={project.id}
                type="button"
                className="pg-grid__card"
                onClick={() => onProjectClick(project)}
              >
                <div className="pg-grid__icon">{project.icon}</div>
                <div className="pg-grid__name">{project.name}</div>
                <div className="pg-grid__desc">{project.description}</div>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProjectGrid;
